import type { PodiumResponse } from '../../api/games';
import styles from './PodiumCard.module.css';

type Props = {
  podium: PodiumResponse;
  weaponMode: boolean;
};

const PLACE = ['', '1st', '2nd', '3rd'];

function placeLabel(i: number) {
  return PLACE[i + 1] ?? `${i + 1}th`;
}

export function PodiumCard({ podium, weaponMode }: Props) {
  const { last_standing, most_kills, gods_favorite, kill_ranking } = podium;

  const awards = [
    { label: 'Last standing', name: last_standing, emoji: '🏆' },
    { label: 'Most kills', name: most_kills, emoji: '☠' },
    { label: "God's favorite", name: gods_favorite, emoji: '🕊' },
  ].filter((a) => a.name !== null);

  return (
    <div className={styles.root}>
      {awards.length > 0 && (
        <div className={styles.awards}>
          {awards.map((a) => (
            <div key={a.label} className={styles.award}>
              <span className={styles.awardEmoji}>{a.emoji}</span>
              <span className={styles.awardName}>{a.name}</span>
              <span className={styles.awardLabel}>{a.label}</span>
            </div>
          ))}
        </div>
      )}

      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.th}>#</th>
            <th className={styles.th}>Player</th>
            <th className={styles.th}>Kills</th>
            {weaponMode && <th className={styles.th}>Weapons used</th>}
          </tr>
        </thead>
        <tbody>
          {kill_ranking.map((entry, i) => (
            <tr
              key={entry.name}
              className={`${styles.row} ${entry.status === 'active' ? styles.winner : ''}`}
            >
              <td className={styles.td}>{placeLabel(i)}</td>
              <td className={styles.td}>
                {entry.name}
                {entry.status === 'active' && <span className={styles.winnerTag}>winner</span>}
                {entry.status === 'arrested' && <span className={styles.arrestedTag}>arrested</span>}
              </td>
              <td className={styles.td}>{entry.kills}</td>
              {weaponMode && (
                <td className={styles.td}>
                  {entry.weapons_collected.length > 0
                    ? entry.weapons_collected.join(', ')
                    : <span className={styles.none}>—</span>}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
